import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RootCloseWrapper from 'react-overlays/lib/RootCloseWrapper';
import OrderForm from '../../containers/OrderFormWrapper/OrderFormWrapper';

class OrderFormMobileWrapper extends Component {
  constructor(props) {
    super(props);

    this.handleRootClose = this.handleRootClose.bind(this);
  }

  handleRootClose(event) {
    this.props.onClose(event, { source: 'rootClose' });
  }

  render() {
    const {
      open, selectedLocations,
    } = this.props;
    const holePage = document.getElementsByTagName('body')[0];

    const bodyScroll = (open && selectedLocations.length > 0) // eslint-disable-line no-unused-vars
      ? holePage.style.overflow = 'hidden'
      : holePage.style.overflow = 'auto';

    return (
      <RootCloseWrapper
        disabled={!open}
        onRootClose={this.handleRootClose}
      >
        <div className="dropdown-menu">
          <OrderForm noScroll handleClose={this.handleRootClose} />
        </div>
      </RootCloseWrapper>
    );
  }
}

OrderFormMobileWrapper.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  selectedLocations: PropTypes.arrayOf(PropTypes.object),
};

OrderFormMobileWrapper.defaultProps = {
  onClose: () => true,
  open: false,
  selectedLocations: [],
};

export default OrderFormMobileWrapper;
